export const getNextFetchStartDate = (
  items: Array<{ year: number; month: number }>
): Date => {
  if (items.length === 0) {
    const date = new Date();
    date.setMonth(date.getMonth() - 11); // Last 12 months
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  // Find latest year/month
  const latest = items.reduce(
    (acc, item) => {
      if (
        item.year > acc.year ||
        (item.year === acc.year && item.month > acc.month)
      ) {
        return { year: item.year, month: item.month };
      }
      return acc;
    },
    { year: -1, month: -1 }
  );

  // Next month after latest
  const nextMonth = latest.month - 1;
  const year = nextMonth > 11 ? latest.year + 1 : latest.year;
  const month = nextMonth > 11 ? 0 : nextMonth;

  return new Date(year, month, 1);
};
